<li class="em-c-tree__item" *ngFor="let nav of navigation">
  <a *ngIf="!nav.route && !nav.url && !nav.children" class="em-c-tree__link"><span class="em-c-tree__text">{{ nav.label }}</span></a>
  <a *ngIf="nav.route && !nav.children" [routerLink]="nav.route" [fragment]="nav.fragment" class="em-c-tree__link" [class.em-is-active]="isActivePage(nav.route, nav.fragment ?? '')"
     #routeLink [name]="nav.route + (nav.fragment ?? '')">
    <span class="em-c-tree__text">{{ nav.label }}</span>
  </a>
  <a *ngIf="nav.url && !nav.route && !nav.children" [href]="nav.url" class="em-c-tree__link">
    <span class="em-c-tree__text">{{ nav.label }}</span>
  </a>
  <a *ngIf="nav.children" href="#" class="em-c-tree__link em-c-tree__link--has-children em-js-tree-dropdown-trigger" role="tab" aria-controls="" aria-expanded="false" aria-selected="false">
    <span class="em-c-tree__text">{{ nav.label }}</span>
    <svg class="em-c-icon em-c-icon--small em-c-tree__icon">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="unity/images/em-icons.svg#caret-right"></use>
    </svg>
  </a>
  <ul au-sub-tree-navigation *ngIf="nav.children" [navigation]="nav.children" [route]="route ?? ''" [fragment]="fragment ?? ''"></ul>
</li>